import React, { Component } from 'react'

import styles from './styles'

class Home extends Component {
	render() {
		const { style } = this.props

		return (
			<div style={{ ...styles.container, ...style }}>
				<div>
					<div style={styles.contact}>
						<i className="fa fa-envelope-open-o" style={styles.icon} />
						bobby@bobbyhacker.tv
					</div>
					<div style={styles.contact}>
						<i className="fa fa-phone" style={styles.icon} />
						310.890.4675
					</div>
					<div style={styles.contact}>
						<i className="fa fa-address-book-o" style={styles.icon} />
						<span
							style={{
								display: 'flex',
								flexDirection: 'column',
								alignItems: 'flex-start'
							}}
						>
							<div style={{ lineHeight: 1.4 }}>3618 Pacific Avenue</div>
							<div style={{ lineHeight: 1.4 }}>Marina del Rey, CA 90292</div>
						</span>
					</div>
				</div>
			</div>
		)
	}
}

export default Home



// WEBPACK FOOTER //
// ./src/views/Contact/index.js